import ContentHeader from "../../../layout/ContenteHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";

const DocumentsHeader = () => {
  return (
    <ContentHeader>
      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        <div style={{
          width: "46px",
          height: "46px",
          borderRadius: "12px",
          background: "linear-gradient(135deg, #00838f 0%, #006064 100%)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
          flexShrink: 0,
          boxShadow: "0 4px 12px rgba(0,131,143,0.3)",
        }}>
          <FontAwesomeIcon icon={faFolderOpen} />
        </div>
        <div>
          <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#212121", lineHeight: 1.2 }}>
            Documents
          </div>
          <div style={{ fontSize: "0.85rem", color: "#9e9e9e", marginTop: "2px" }}>
            Manage your files and documents
          </div>
        </div>
      </div>
    </ContentHeader>
  );
};

export default DocumentsHeader;
